export const ACTIONS = {
  CHANGE_PASSWORD: "change_password",
  GET_PIN_CODE: "gnadmin/get_pin_code",
  GET_CENTRE_CODE: "gnadmin/get_centre_code",
  GET_CITIES: "gnadmin/get_cities",
  GET_AREA: "gnadmin/get_area",
  GET_AGENTS: "gnadmin/get_agents",
  GET_AGENTS_BY_USERGROUP: "gnadmin/get_agents_by_usergroup",
  GET_PACKAGE_BY_NAME: "gnadmin/get_package_by_name",
  GET_BANK_NAME: "gnadmin/get_bank_name",
  GET_ALL_PACKAGES: "gnadmin/get_all_packages",
  GET_PACKAGES: "gnadmin/get_packages",
  GET_PHLEBOS: "gnadmin/get_phlebos",
  GET_PARTNERS: "gnadmin/get_partners",
  GET_BOOKING_STATUS: "gnadmin/get_booking_status",
  GET_COUPONS: "gnadmin/get_coupons",
  GET_CAMPCOUPONS: "gnadmin/get_campcoupons",
  CREATE_BOOKING: "gnadmin/create_booking",
  CREATE_CENTRE_LAB_ORG: "gnadmin/create_centre_lab_org",
  CREATE_USERS: "gnadmin/create_users",
  GET_CENTRE_LAB_ORG: "gnadmin/get_centre_lab_org",
  CREATE_NEW_CENTER: "gnadmin/create_new_center",
  CREATE_RATELIST: "gnadmin/create_ratelist",
  CREATE_INVOICE: "gnadmin/create_invoice",
  ATTACH_RATELIST: "gnadmin/attach_ratelist",
  UPLOAD_RATELIST: "gnadmin/upload_ratelist",
  GET_RATELIST: "gnadmin/get_ratelist",
  GET_RATELIST_EXPORT: "gnadmin/get_ratelist_export",
  GET_RATELIST_FILTER: "gnadmin/get_ratelist_filter",
  GET_RATELIST_PACKAGE: "gnadmin/get_ratelist_package",
  UPDATE_BOOKING: "gnadmin/update_booking",
  GET_BOOKING_LIST: "gnadmin/get_booking_list",
  GET_TAT_TESTS: "gnadmin/get_tat_tests",
  GET_TAT_TESTS_NAMES: "gnadmin/get_tat_tests_names",
  UPDATE_TAT_TESTS: "gnadmin/update_tat_tests",
  GET_LEAD_DETAILS: "gnadmin/get_lead_details",
  GET_LEAD_BY_ID: "gnadmin/get_lead_by_id",
  LEAD_DETAILS_RESET: "gnadmin/lead_details_reset",
  GET_LEADS: "gnadmin/get_leads",
  GET_BOOKING_BY_ID: "gnadmin/get_booking_by_id",
  CLICK_TO_CALL: "gnadmin/click_to_call",
  GET_POSTIVE_CALLS_COMMENTS: "gnadmin/get_postive_calls_commnets",
  ADD_POSTIVE_CALLS_COMMENT: "gnadmin/add_comments",
  SET_COMMENTS: "gnadmin/set_commnets",
  UPLOAD_FILE: "gnadmin/upload",
  SET_LOADING: "gnadmin/set_loading",
  SEARCH_CALL: "gnadmin/serach",
  BOOKING_RESET: "gnadmin/booking_reset",
  ADD_COMMENT: "positive_calls/add_comment",
  CREATE_CALL: "gnadmin/createcall",
  GET_LEAD_SOURCE: "gnadmin/getleadsource",
  GET_LAB_ORG_CODE: "gnadmin/getlaborgcode",
  GET_RECORDINGS: "gnadmin/get_recordings",
  GET_BOOKINGS_COMMENTS: "gnadmin/get_bookings_commnets",
  ADD_BOOKINGS_COMMENT: "gnadmin/add_bookings_comments",
  GET_WHATSAPP_COMMENTS: "gnadmin/get_whatsapp_comments",
  GET_WHATSAPP_COMMENTS_BY_LEAD: "gnadmin/get_whatsapp_comments_by_lead",
  SEND_WHATSAPP_COMMENTS: "gnadmin/send",
  GET_CALL_STATS: "gnadmin/get_call_stats",
  RAISE_COMPLAINT: "gnadmin/raise_complaint",
  GET_COMPLAINTS: "gnadmin/get_complaints",
  ASSIGN_DOCTOR: "gnadmin/assign_doctor",
  SEND_FEEDBACK: "gnadmin/send_feedback",
  GET_AVAILABLE_SLOTS: "gnadmin/get_available_slots",
  GET_ALL_LEADS: "gnadmin/get_all_leads",
  LEAD_TRANSFER_BY_COMMA: "gnadmin/set_comments",
  GET_PANEL_USERS: "gnadmin/get_panel_user",
  GET_CENTRE_CREATION_MASTER_ADVANCE_PAYMENT:
    "gnadmin/get_centre_creation_master__advance_payment",
  POST_ADVANCE_PAYMENT: "gnadmin/post_advance_payment",
  CREATE_QR_PAYMENT: "gnadmin/create_qr_payment",
  CREATE_LINK_PAYMENT: "gnadmin/create_link_payment",
  GET_CENTER_INFORMATION: "gnadmin/get_center_information",
  GET_CENTRE_USERS: "gnadmin/get_centre_users",
  GET_CENTERS: "gnadmin/get_centers",
  GET_CENTRE_INVOICE: "gnadmin/get_centre_invoice",
  EXPORT_CCLEDGER: "gnadmin/exportccledger",
  GET_CENTRE_PROCESSING_RATE: "gnadmin/get_centre_processing_rate",
  POST_CENTRE_PROCESSING_RATE: "gnadmin/post_centre_processing_rate",
  UPDATE_CENTRE_PROCESSING_RATE: "gnadmin/update_centre_processing_rate",
  GET_LAB_CREDENTIAL: "gnadmin/get_lab_cred",
  GET_USER_DETAILS: "gnadmin/get_user_details",
  GET_ADVANCE_PAYMENT: "gnadmin/advance-payment/",
  GET_RECHARGE: "gnadmin/get_recharge/",
  GET_CLIENT_LEDGER_DETAILS: "gnadmin/get_client_ledger_details",
  GET_CLIENT_LEDGER_BALANCE: "gnadmin/get_client_ledger_balance",
  GET_SALES_SUMMARY: "gnadmin/get_sales_summary",
  GET_CENTRE_CAMP_PACKAGE: "gnadmin/get_centre_camp_package",
  GET_CAMP_PACKAGES: "gnadmin/get_camp_packages",
  POST_CENTRE_CAMP_PACKAGE: "gnadmin/post_centre_camp_package",
  UPDATE_CENTRE_CAMP_PACKAGE: "gnadmin/update_centre_camp_package",
  POST_RATE_LIST: "gnadmin/post_rate_list",
  UPDATE_RATE_LIST: "gnadmin/update_rate_list",
  GET_LAB_DETAILS: "gnadmin/get_lab_details",
  GET_MAMPMYINDIA_ACCESS_TOKEN: "gnadmin/get-mapmyindia-access-token",
  CHECK_GEOFENCE_AREA: "gnadmin/checking-geofence-area",
  CHECK_GEOFENCE_AREA_MAMPMYINDIA: "gnadmina/checking-geofence-area-mapmyindia",
  SAME_NUMBER_BOOKING: "gnadmin/same_number_booking",
  GET_TIMESLOTS: "gnadmin/get_timeslot",
  CREATE_IMAGING_BOOKING: "gnadmin/get_imaging_booking",
  CREATE_PROMO_CAMP: "gnadmin/get_promo_camp",
  GET_SALES_EXECUTIVE: "gnadmin/get_sales_executive",
  GET_SALES_MANAGER: "gnadmin/get_sales_manager",
  GET_USERS_RIGHTS: "gnadmin/get_users_rights",
  UPDATE_CENTER: "gnadmin/update_center",
  GET_IENTITY_PROOF_DATA: "gnadmin/get_identity_proof_data",
  GET_STATE_LIST: "gnadmin/get_state_list",
  GET_PAYMENT_MODE_LIST: "gnadmin/get_payment_mode_list",
  GET_TEST_CATEGORY: "gnadmin/get_test_category",
  GET_RED_COIN: "gnadmin/get_red_coin",
  GET_TAG_PROCCESSING_LAB: "gnadmin/get_tag_proccessing_lab",
  GET_REPORT_STATUS: "gnadmin/get_report_status",
  GET_BOOKING_STATUS_COUNT: "gnadmin/get_booking_status_count",
  GET_REPORT_DOWNLOAD: "gnadmin/get_report_download",
  GET_REPORT_DOWNLOAD_WITHOUT: "gnadmin/get_report_download_without",
  GET_DOCTOR_INFO_BY_ID: "gnadmin/get_doctor_info",
  GET_DISPLAY_CITIES: "gnadmin/get_display_cities",
  GET_MULTIPLE_PACKAGES: "gnadmin/get_multiple_package",
  GET_IMAGING_TIMESLOTS: "gnadmin/get_imaging_timeslots",
  GET_SUB_CENTER_INFORMATION: "gnadmin/get_sub_center_information",
  UPDATE_EMPLOYEE: "gnadmin/update_employee",
  POST_EMPLOYEE: "gnadmin/post_employee",
  GET_EMPLOYEE: "gnadmin/get_employee",
  GET_PAYMENT_SEND_LINK: "gnadmin/get_payment_send_link",
  GET_PAYMENT_RESEND_LINK: "gnadmin/get_payment_resend_link",
  GET_REF_DOCTOR: "gnadmin/get_ref_doctor",
  GET_DOCTOR_QUAL: "gnadmin/get_doctor_qual",
  GET_DOCTOR_SPEC: "gnadmin/get_doctor_spec",
  POST_REF_DOCTOR: "gnadmin/post_ref_doctor",
  REF_DOCTOR_RESET: "gnadmin/ref_doctor_reset",
  BOOKING_DATA_RESET: "gnadmin/booking_data_reset",
  GET_RECEIVED_PACKAGES: "gnadmin/get_received_packages",
  GET_TUBE_BY_BOOKING: "gnadmin/get_tube_by_booking",
  POST_SAMPLE_COLLECTION: "gnadmin/post_sample_collection",
  GET_PACKAGES_BY_CENTER: "gnadmin/get_package_by_center",
  GET_ZONE: "gnadmin/get_zone",
  GET_BOOKINGS_BY_CENTRE: "gnadmin/get_booking_by_centre",
  UPDATE_REF_UPDATE: "gnadmin/update_ref_update",

};
interface GetEmployee {
  type: typeof ACTIONS.GET_EMPLOYEE;
  payload: Array<any>;
}
interface UpdaterefDoctor {
  type: typeof ACTIONS.UPDATE_REF_UPDATE;
  payload: Array<any>;
}
interface GetBookingsByCentre {
  type: typeof ACTIONS.GET_BOOKINGS_BY_CENTRE;
  payload: boolean;
}
interface GetZone {
  type: typeof ACTIONS.GET_ZONE;
  payload: Object;
}
interface PostSampleCollection {
  type: typeof ACTIONS.POST_SAMPLE_COLLECTION;
  payload: Array<any>;
}
interface GetTubeByBooking {
  type: typeof ACTIONS.GET_TUBE_BY_BOOKING;
  payload: boolean;
}
interface GetReceivedPackages {
  type: typeof ACTIONS.GET_RECEIVED_PACKAGES;
  payload: Array<any>;
}
interface BookingDataReset {
  type: typeof ACTIONS.BOOKING_DATA_RESET;
  payload: boolean;
}
interface RefDoctorReset {
  type: typeof ACTIONS.REF_DOCTOR_RESET;
  payload: boolean;
}
interface PostRefDoctor {
  type: typeof ACTIONS.POST_REF_DOCTOR;
  payload: Array<any>;
}
interface GetDoctorSpec {
  type: typeof ACTIONS.GET_DOCTOR_SPEC;
  payload: Array<any>;
}
interface GetDoctorQual {
  type: typeof ACTIONS.GET_DOCTOR_QUAL;
  payload: Array<any>;
}
interface GetRefDoctor {
  type: typeof ACTIONS.GET_REF_DOCTOR;
  payload: Array<any>;
}
interface GetPaymentReSendLink {
  type: typeof ACTIONS.GET_PAYMENT_RESEND_LINK;
  payload: Object;
}
interface PostEmployee {
  type: typeof ACTIONS.POST_EMPLOYEE;
  payload: boolean;
}
interface GetPaymentSendLink {
  type: typeof ACTIONS.GET_PAYMENT_SEND_LINK;
  payload: Object;
}
interface UpdateEmployee {
  type: typeof ACTIONS.UPDATE_EMPLOYEE;
  payload: boolean;
}
interface GetSubCenterInformation {
  type: typeof ACTIONS.GET_SUB_CENTER_INFORMATION;
  payload: Array<any>;
}
interface GetImagingTimeSlots {
  type: typeof ACTIONS.GET_IMAGING_TIMESLOTS;
  payload: Array<any>;
}
interface GetMultiplepackage {
  type: typeof ACTIONS.GET_MULTIPLE_PACKAGES;
  payload: Array<any>;
}
interface GetDisplayCities {
  type: typeof ACTIONS.GET_DISPLAY_CITIES;
  payload: Array<any>;
}
interface getDoctorInfoById {
  type: typeof ACTIONS.GET_DOCTOR_INFO_BY_ID;
  payload: object;
}
interface GetUsersRights {
  type: typeof ACTIONS.GET_USERS_RIGHTS;
  payload: boolean;
}
interface ReportDownloadWithout {
  type: typeof ACTIONS.GET_REPORT_DOWNLOAD_WITHOUT;
  payload: boolean;
}
interface GetLabOrgCode {
  type: typeof ACTIONS.GET_LAB_ORG_CODE;
  payload: boolean;
}
interface ReportDownload {
  type: typeof ACTIONS.GET_REPORT_DOWNLOAD;
  payload: boolean;
}
interface GetBookingStatusCount {
  type: typeof ACTIONS.GET_BOOKING_STATUS_COUNT;
  payload: Array<any>;
}
interface GetReportStatus {
  type: typeof ACTIONS.GET_REPORT_STATUS;
  payload: Array<any>;
}
interface GetBookingStatus {
  type: typeof ACTIONS.GET_BOOKING_STATUS;
  payload: Array<any>;
}
interface GetAllPackages {
  type: typeof ACTIONS.GET_ALL_PACKAGES;
  payload: Array<any>;
}
interface GetPackageByName {
  type: typeof ACTIONS.GET_PACKAGE_BY_NAME;
  payload: Array<any>;
}
interface GetBankName {
  type: typeof ACTIONS.GET_BANK_NAME;
  payload: Array<any>;
}
interface GetMapMyIndiaAccessToken {
  type: typeof ACTIONS.GET_MAMPMYINDIA_ACCESS_TOKEN;
  payload: Array<any>;
}
interface GetTagProccessingLab {
  type: typeof ACTIONS.GET_TAG_PROCCESSING_LAB;
  payload: Array<any>;
}
interface GetLabCredential {
  type: typeof ACTIONS.GET_LAB_CREDENTIAL;
  payload: Array<any>;
}
interface GetSalesExecutive {
  type: typeof ACTIONS.GET_SALES_EXECUTIVE;
  payload: Array<any>;
}
interface GetRedCoin {
  type: typeof ACTIONS.GET_RED_COIN;
  payload: Array<any>;
}
interface GetTestCategory {
  type: typeof ACTIONS.GET_TEST_CATEGORY;
  payload: Array<any>;
}
interface GetPaymentModeList {
  type: typeof ACTIONS.GET_PAYMENT_MODE_LIST;
  payload: Array<any>;
}
interface GetIdentityProof {
  type: typeof ACTIONS.GET_IENTITY_PROOF_DATA;
  payload: Array<any>;
}
interface GetStateList {
  type: typeof ACTIONS.GET_STATE_LIST;
  payload: Array<any>;
}
interface UpdateCenter {
  type: typeof ACTIONS.UPDATE_CENTER;
  payload: Array<any>;
}
interface GetSalesManager {
  type: typeof ACTIONS.GET_SALES_MANAGER;
  payload: Array<any>;
}
interface CheckGeoFenceArea {
  type: typeof ACTIONS.CHECK_GEOFENCE_AREA;
  payload: Array<any>;
}
interface CheckGeoFenceAreaMapMyIndia {
  type: typeof ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA;
  payload: Array<any>;
}
interface GetPinCode {
  type: typeof ACTIONS.GET_PIN_CODE;
  payload: Array<any>;
}
interface GetCentreCode {
  type: typeof ACTIONS.GET_CENTRE_CODE;
  payload: Array<any>;
}
interface GetLabDetails {
  type: typeof ACTIONS.GET_LAB_DETAILS;
  payload: Array<any>;
}
interface GetUserDetails {
  type: typeof ACTIONS.GET_USER_DETAILS;
  payload: Array<any>;
}
interface ChangePassword {
  type: typeof ACTIONS.CHANGE_PASSWORD;
  payload: Object;
}

interface UploadFile {
  type: typeof ACTIONS.UPLOAD_FILE;
  payload: Object;
}

interface GetCities {
  type: typeof ACTIONS.GET_CITIES;
  payload: Array<any>;
}

interface GetArea {
  type: typeof ACTIONS.GET_AREA;
  payload: Array<any>;
}

interface GetAgents {
  type: typeof ACTIONS.GET_AGENTS;
  payload: Array<any>;
}

interface GetPhlebo {
  type: typeof ACTIONS.GET_PHLEBOS;
  payload: Array<any>;
}

interface SetComments {
  type: typeof ACTIONS.SET_COMMENTS;
  payload: Object;
}

interface GetPositiveCallsComments {
  type: typeof ACTIONS.GET_POSTIVE_CALLS_COMMENTS;
  payload: Object;
}

interface AddPositiveCallsComments {
  type: typeof ACTIONS.ADD_POSTIVE_CALLS_COMMENT;
  payload: Object;
}

interface ClickToCall {
  type: typeof ACTIONS.CLICK_TO_CALL;
  payload: Array<any>;
}

interface GetPackages {
  type: typeof ACTIONS.GET_PACKAGES;
  payload: Array<any>;
}

interface GetPartners {
  type: typeof ACTIONS.GET_PARTNERS;
  payload: Array<any>;
}

interface GetCoupons {
  type: typeof ACTIONS.GET_COUPONS;
  payload: Array<any>;
}
interface GetCampCoupons {
  type: typeof ACTIONS.GET_CAMPCOUPONS;
  payload: Array<any>;
}
interface SetLoading {
  type: typeof ACTIONS.SET_LOADING;
  payload: boolean;
}
interface CreateCentreLabOrg {
  type: typeof ACTIONS.CREATE_CENTRE_LAB_ORG;
  payload: boolean;
}
interface CreateUsers {
  type: typeof ACTIONS.CREATE_USERS;
  payload: boolean;
}
interface GetCentreLabOrg {
  type: typeof ACTIONS.GET_CENTRE_LAB_ORG;
  payload: boolean;
}
interface CreateBooking {
  type: typeof ACTIONS.CREATE_BOOKING;
  payload: boolean;
}
interface CreateNewCenter {
  type: typeof ACTIONS.CREATE_NEW_CENTER;
  payload: boolean;
}
interface CreateRatelist {
  type: typeof ACTIONS.CREATE_RATELIST;
  payload: boolean;
}
interface CreateInvoice {
  type: typeof ACTIONS.CREATE_INVOICE;
  payload: boolean;
}
interface AttachRatelist {
  type: typeof ACTIONS.ATTACH_RATELIST;
  payload: boolean;
}
interface UploadRatelist {
  type: typeof ACTIONS.UPLOAD_RATELIST;
  payload: boolean;
}
interface GetRatelist {
  type: typeof ACTIONS.GET_RATELIST;
  payload: boolean;
}
interface GetRatelistExport {
  type: typeof ACTIONS.GET_RATELIST_EXPORT;
  payload: boolean;
}
interface GetRatelistFilter {
  type: typeof ACTIONS.GET_RATELIST_FILTER;
  payload: boolean;
}
interface GetRatelistPackage {
  type: typeof ACTIONS.GET_RATELIST_PACKAGE;
  payload: boolean;
}
interface UpdateBooking {
  type: typeof ACTIONS.UPDATE_BOOKING;
  payload: boolean;
}

interface GetBookings {
  type: typeof ACTIONS.GET_BOOKING_LIST;
  payload: boolean;
}

interface GetBookingById {
  type: typeof ACTIONS.GET_BOOKING_BY_ID;
  payload: boolean;
}

interface GetLeads {
  type: typeof ACTIONS.GET_LEADS;
  payload: boolean;
}

interface GetLeadDetails {
  type: typeof ACTIONS.GET_LEAD_DETAILS;
  payload: boolean;
}

interface GetLeadById {
  type: typeof ACTIONS.GET_LEAD_BY_ID;
  payload: boolean;
}

interface ResetLeadDetails {
  type: typeof ACTIONS.LEAD_DETAILS_RESET;
  payload: boolean;
}
interface GetTimeSlot {
  type: typeof ACTIONS.GET_TIMESLOTS;
  payload: Array<any>;
}
interface GetPinCode {
  type: typeof ACTIONS.GET_PIN_CODE;
  payload: Array<any>;
}
interface ChangePassword {
  type: typeof ACTIONS.CHANGE_PASSWORD;
  payload: Object;
}
interface GetCities {
  type: typeof ACTIONS.GET_CITIES;
  payload: Array<any>;
}

interface GetArea {
  type: typeof ACTIONS.GET_AREA;
  payload: Array<any>;
}
interface GetPhlebo {
  type: typeof ACTIONS.GET_PHLEBOS;
  payload: Array<any>;
}

interface GetAgents {
  type: typeof ACTIONS.GET_AGENTS;
  payload: Array<any>;
}

interface SetComments {
  type: typeof ACTIONS.SET_COMMENTS;
  payload: Object;
}

interface GetPositiveCallsComments {
  type: typeof ACTIONS.GET_POSTIVE_CALLS_COMMENTS;
  payload: Object;
}

interface AddPositiveCallsComments {
  type: typeof ACTIONS.ADD_POSTIVE_CALLS_COMMENT;
  payload: Object;
}
interface ClickToCall {
  type: typeof ACTIONS.CLICK_TO_CALL;
  payload: Array<any>;
}

interface GetPackages {
  type: typeof ACTIONS.GET_PACKAGES;
  payload: Array<any>;
}

interface GetPartners {
  type: typeof ACTIONS.GET_PARTNERS;
  payload: Array<any>;
}

interface GetCoupons {
  type: typeof ACTIONS.GET_COUPONS;
  payload: Array<any>;
}

interface SetLoading {
  type: typeof ACTIONS.SET_LOADING;
  payload: boolean;
}

interface CreateBooking {
  type: typeof ACTIONS.CREATE_BOOKING;
  payload: boolean;
}

interface GetTatTests {
  type: typeof ACTIONS.GET_TAT_TESTS;
  payload: boolean;
}
interface GetTatTestsNames {
  type: typeof ACTIONS.GET_TAT_TESTS_NAMES;
  payload: boolean;
}
interface UpdateTatTests {
  type: typeof ACTIONS.UPDATE_TAT_TESTS;
  payload: boolean;
}
interface GetBookingById {
  type: typeof ACTIONS.GET_BOOKING_BY_ID;
  payload: boolean;
}

interface GetLeads {
  type: typeof ACTIONS.GET_LEADS;
  payload: boolean;
}

interface GetLeadDetails {
  type: typeof ACTIONS.GET_LEAD_DETAILS;
  payload: boolean;
}

interface GetLeadById {
  type: typeof ACTIONS.GET_LEAD_BY_ID;
  payload: boolean;
}

interface ResetLeadDetails {
  type: typeof ACTIONS.LEAD_DETAILS_RESET;
  payload: boolean;
}
interface SearchCall {
  type: typeof ACTIONS.SEARCH_CALL;
  payload: Object;
}
interface SearchCall {
  type: typeof ACTIONS.SEARCH_CALL;
  payload: Object;
}
interface GetAgentByUserGroup {
  type: typeof ACTIONS.GET_AGENTS_BY_USERGROUP;
  payload: Object;
}
interface GetCebterCreationMasterAdvancePayment {
  type: typeof ACTIONS.GET_CENTRE_CREATION_MASTER_ADVANCE_PAYMENT;
  payload: Array<any>;
}
interface PostAdvancePayment {
  type: typeof ACTIONS.POST_ADVANCE_PAYMENT;
  payload: Array<any>;
}
interface CreateQrPayment {
  type: typeof ACTIONS.CREATE_QR_PAYMENT;
  payload: Array<any>;
}
interface CreateLinkPayment {
  type: typeof ACTIONS.CREATE_LINK_PAYMENT;
  payload: Array<any>;
}
interface GetCenterInfo {
  type: typeof ACTIONS.GET_CENTER_INFORMATION;
  payload: Array<any>;
}
interface GetCentreUsers {
  type: typeof ACTIONS.GET_CENTRE_USERS;
  payload: Array<any>;
}
interface GetCenters {
  type: typeof ACTIONS.GET_CENTERS;
  payload: Array<any>;
}
interface GetCentreInvoice {
  type: typeof ACTIONS.GET_CENTRE_INVOICE;
  payload: Array<any>;
}
interface ExportCCLedger {
  type: typeof ACTIONS.EXPORT_CCLEDGER;
  payload: Array<any>;
}
interface GetCenterProcessingRate {
  type: typeof ACTIONS.GET_CENTRE_PROCESSING_RATE;
  payload: Array<any>;
}
interface PostCenterProcessingRate {
  type: typeof ACTIONS.POST_CENTRE_PROCESSING_RATE;
  payload: Array<any>;
}
interface UpdateCenterProcessingRate {
  type: typeof ACTIONS.UPDATE_CENTRE_PROCESSING_RATE;
  payload: Array<any>;
}

interface GetAdvancePayment {
  type: typeof ACTIONS.GET_ADVANCE_PAYMENT;
  payload: Array<any>;
}
interface GetRecharge {
  type: typeof ACTIONS.GET_RECHARGE;
  payload: Array<any>;
}
interface GetClientLedgerDetails {
  type: typeof ACTIONS.GET_CLIENT_LEDGER_DETAILS;
  payload: Array<any>;
}
interface GetClientLedgerBalance {
  type: typeof ACTIONS.GET_CLIENT_LEDGER_BALANCE;
  payload: Array<any>;
}
interface GetSalesSummary {
  type: typeof ACTIONS.GET_SALES_SUMMARY;
  payload: Array<any>;
}
interface GetCentreCampPackage {
  type: typeof ACTIONS.GET_CENTRE_CAMP_PACKAGE;
  payload: Array<any>;
}
interface GetCampPackage {
  type: typeof ACTIONS.GET_CAMP_PACKAGES;
  payload: Array<any>;
}
interface PostCentreCampPackage {
  type: typeof ACTIONS.POST_CENTRE_CAMP_PACKAGE;
  payload: Array<any>;
}
interface UpdateCentreCampPackage {
  type: typeof ACTIONS.UPDATE_CENTRE_CAMP_PACKAGE;
  payload: Array<any>;
}
interface SameNumberBooking {
  type: typeof ACTIONS.SAME_NUMBER_BOOKING;
  payload: Object;
}
interface CreateImagingBooking {
  type: typeof ACTIONS.CREATE_IMAGING_BOOKING;
  payload: boolean;
}
interface CreatePromoCamp {
  type: typeof ACTIONS.CREATE_PROMO_CAMP;
  payload: boolean;
}
interface PostRateList {
  type: typeof ACTIONS.POST_RATE_LIST;
  payload: Array<any>;
}
interface UpdateRateList {
  type: typeof ACTIONS.UPDATE_RATE_LIST;
  payload: Array<any>;
}
interface GetPackageByCenter {
  type: typeof ACTIONS.GET_PACKAGES_BY_CENTER;
  payload: Array<any>;
}

export type GenomicsAdminTypes =
  | SearchCall
  | GetCentreCampPackage
  | GetSalesSummary
  | GetUserDetails
  | GetBookingStatusCount
  | UpdateRateList
  | CreatePromoCamp
  | GetPinCode
  | ChangePassword
  | CreateQrPayment
  | CreateLinkPayment
  | GetRecharge
  | GetCentreUsers
  | GetCities
  | GetCampPackage
  | GetArea
  | GetAgents
  | GetPhlebo
  | GetAgentByUserGroup
  | GetPackages
  | CreateBooking
  | UpdateBooking
  | GetPartners
  | GetCoupons
  | GetBookings
  | GetBookingById
  | SetLoading
  | GetLeadDetails
  | GetLeads
  | GetLeadById
  | ResetLeadDetails
  | ClickToCall
  | GetPositiveCallsComments
  | AddPositiveCallsComments
  | SetComments
  | UploadFile
  | GetPinCode
  | ChangePassword
  | GetCities
  | GetArea
  | GetAgents
  | GetRatelistExport
  | GetPhlebo
  | GetPackages
  | CreateBooking
  | UpdateBooking
  | GetPartners
  | GetCoupons
  | GetBookings
  | GetBookingById
  | SetLoading
  | UpdateCentreCampPackage
  | GetLeadDetails
  | GetLeads
  | GetLeadById
  | ResetLeadDetails
  | ClickToCall
  | GetPositiveCallsComments
  | AddPositiveCallsComments
  | SetComments
  | SearchCall
  | GetCampCoupons
  | GetCebterCreationMasterAdvancePayment
  | PostAdvancePayment
  | GetCenterInfo
  | GetAdvancePayment
  | GetClientLedgerDetails
  | PostRateList
  | CreateNewCenter
  | GetLabDetails
  | CheckGeoFenceArea
  | CheckGeoFenceAreaMapMyIndia
  | GetMapMyIndiaAccessToken
  | GetTimeSlot
  | SameNumberBooking
  | CreateImagingBooking
  | GetSalesExecutive
  | GetSalesManager
  | GetBankName
  | UpdateCenter
  | GetIdentityProof
  | GetStateList
  | GetPaymentModeList
  | GetTestCategory
  | GetRedCoin
  | GetTagProccessingLab
  | UpdateCenterProcessingRate
  | PostCenterProcessingRate
  | GetCenterProcessingRate
  | CreateRatelist
  | AttachRatelist
  | UploadRatelist
  | GetRatelist
  | GetRatelistFilter
  | PostCentreCampPackage
  | GetRatelistPackage
  | GetCenters
  | GetClientLedgerBalance
  | CreateCentreLabOrg
  | GetCentreLabOrg
  | GetLabOrgCode
  | GetTatTests
  | UpdateTatTests
  | GetCentreInvoice
  | CreateInvoice
  | GetCentreCode
  | GetTatTestsNames
  | GetPackageByName
  | GetAllPackages
  | GetBookingStatus
  | GetReportStatus
  | ExportCCLedger
  | ReportDownload
  | GetUsersRights
  | ReportDownloadWithout
  | CreateUsers
  | GetLabCredential
  | GetSubCenterInformation
  | GetImagingTimeSlots
  | GetMultiplepackage
  | GetDisplayCities
  | getDoctorInfoById
  | GetEmployee
  | PostEmployee
  | UpdateEmployee
  | GetPaymentSendLink
  | GetPaymentReSendLink
  | GetDoctorQual
  | GetDoctorSpec
  | PostRefDoctor
  | RefDoctorReset
  | GetRefDoctor
  | PostSampleCollection
  | GetTubeByBooking
  | GetReceivedPackages
  | BookingDataReset
  | GetPackageByCenter
  | GetZone
  | GetBookingsByCentre
  | UpdaterefDoctor
